import React, { useEffect, useState } from "react";
import "./LearnersReport.css";
import axios from "axios";
import { BASE_API_URL } from "../../utils/constants";

const LearnersReport = () => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const fetchReport = async () => {
      try {
        setLoading(true);
        setError("");

        const res = await axios.get(
          `${BASE_API_URL}/powerBI/foundation-report`,
          {
            signal: controller.signal,
          },
        );

        if (isMounted) {
          setReportData(res.data?.[0]);
        }
      } catch (err) {
        if (err.name === "CanceledError") return;

        if (isMounted) {
          setError("Failed to load report");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchReport();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  const level8Above = reportData?.Song?.summary?.level8Above || {};

  const level9To11 = reportData?.Song?.summary?.level9To11 || {};

  if (loading) {
    return <p>Loading ...</p>;
  }

  return (
    <div className="learners-report-container">
      <h2>Learners Report</h2>

      <h3>Completion Summary</h3>

      <table className="report-table">
        <thead>
          <tr>
            <th colSpan="5" className="table-title">
              Level 8 & Above
            </th>
          </tr>
          <tr>
            <th></th>
            <th colSpan="2">Foundation</th>
            <th colSpan="2">Flagship</th>
          </tr>
          <tr>
            <th>Total Learners</th>
            <th>Completion #</th>
            <th>Completion %</th>
            <th>Completion #</th>
            <th>Completion %</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>{level8Above.totalLearners || 0}</td>

            <td>{level8Above.foundationCompletionCount || 0}</td>

            <td>{level8Above.foundationCompletionPct || 0}%</td>

            <td>{level8Above.flagshipCompletionCount || 0}</td>

            <td>{level8Above.flagshipCompletionPct || 0}%</td>
          </tr>
        </tbody>
      </table>

      <table className="report-table second-table">
        <thead>
          <tr>
            <th colSpan="3" className="table-title">
              Level 9 - 11
            </th>
          </tr>

          <tr>
            <th>Total Learners</th>
            <th>Completion #</th>
            <th>Completion %</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>{level9To11.totalLearners || 0}</td>

            <td>{level9To11.foundationCompletionCount || 0}</td>

            <td>{level9To11.foundationCompletionPct || 0}%</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default LearnersReport;
